import { render, staticRenderFns } from "./btn-arrow-primary.vue?vue&type=template&id=ca0f573e&scoped=true&"
import script from "./btn-arrow-primary.vue?vue&type=script&lang=js&"
export * from "./btn-arrow-primary.vue?vue&type=script&lang=js&"
import style0 from "./btn-arrow-primary.vue?vue&type=style&index=0&id=ca0f573e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca0f573e",
  null
  
)

export default component.exports